function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.22625 2.22722C0.145938 4.30754 0.145938 7.69311 2.22625 9.77343C4.30656 11.8537 7.69214 11.8537 9.77245 9.77343C11.8528 7.69311 11.8528 4.30754 9.77245 2.22722C7.69214 0.146915 4.30705 0.146915 2.22625 2.22722ZM8.13084 4.21724L6.43448 5.91359L8.13084 7.60995C8.27501 7.75412 8.27501 7.98767 8.13084 8.13184C7.98667 8.27601 7.75312 8.27601 7.60895 8.13184L5.91259 6.43548L4.21624 8.13184C4.07207 8.27601 3.83852 8.27601 3.69435 8.13184C3.55018 7.98767 3.55018 7.75412 3.69435 7.60995L5.39071 5.91359L3.69435 4.21724C3.55018 4.07307 3.55018 3.83952 3.69435 3.69535C3.83852 3.55118 4.07207 3.55118 4.21624 3.69535L5.91259 5.39171L7.60895 3.69535C7.75312 3.55118 7.98667 3.55118 8.13084 3.69535C8.27501 3.83952 8.27501 4.07307 8.13084 4.21724Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 5.99935,
  y1: 0.666992,
  x2: 5.99935,
  y2: 11.3337,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F56565"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F04242"
})));

var SvgIcoListasExcluir = function SvgIcoListasExcluir(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoListasExcluir, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-listas-excluir.54c44cde.svg";
export { ForwardRef as ReactComponent };